import { Group, Stack } from "@mantine/core";
import { useSuspenseQuery } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";
import { groupQueryOptions } from "../../../../api/useGroup";
import { useGroupExtraData } from "../../../../api/useGroupExtraData";
import { useGroupProgress } from "../../../../api/useGroupProgress";
import PageContainer from "../../../../components/PageContainer/PageContainer";
import GroupExtraDataInfo from "../../../../features/Groups/GroupExtraDataInfo/GroupExtraDataInfo";
import GroupStats from "../../../../features/Groups/GroupStats/GroupStats";
import GroupProgressPage from "../../../../pages/GroupPage/GroupProgressPage/GroupProgressPage";

export const Route = createFileRoute("/(app)/groups/$id/courses")({
  component: RouteComponent,
  loader: ({ params, context }) => {
    return context.queryClient.ensureQueryData(
      groupQueryOptions(Number(params.id)),
    );
  },
  validateSearch: (
    search: Record<string, any>,
  ): {
    c?: string;
    v: string[];
  } => ({
    c: search.c ?? "all",
    v: search.v || [],
  }),
});

function RouteComponent() {
  const { id } = Route.useParams();
  const { data: group } = useSuspenseQuery(groupQueryOptions(Number(id)));

  const { data: groupExtraData } = useGroupExtraData({
    groupId: group.ID,
  });
  const {
    data: groupProgressData,
    isError,
    error,
    refetch,
    isPending,
  } = useGroupProgress({ groupId: Number(id) });
  return (
    <>
      <PageContainer>
        <Stack>
          <Group justify="space-between">
            <GroupStats
              distance={groupProgressData?.TotalTravelDistance}
              runtime={groupProgressData?.TotalRuntime}
              fuel={groupProgressData?.TotalFuelConsumption}
              isError={isError}
              error={error}
              onRetry={() => refetch()}
              isLoading={isPending}
              createdBy={{
                name: group.CreatedByName,
                id: group.CreatedBy,
              }}
            />
            {groupExtraData && <GroupExtraDataInfo data={groupExtraData} />}
          </Group>
        </Stack>
      </PageContainer>

      <GroupProgressPage group={group} />
    </>
  );
}
